// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.breadcrumb {
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}
.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: var(--ca-radius-sm, 6px);
}

.breadcrumb-link i {
  font-size: 1.25rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  font-size: 1.25rem;
}

.dashboard-page {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0.25rem clamp(0.75rem, 2vw, 1.5rem) 2rem;
  color: var(--ca-text-primary, #172033);
}

.dashboard-breadcrumbs {
  margin-bottom: 1.15rem;
}

.dashboard-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;
  margin: 0.25rem 0 2rem;
}

.dashboard-heading-copy {
  min-width: 0;
}

.dashboard-eyebrow {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.55rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.eyebrow-mark {
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 2px;
  background: var(--ca-primary-light, #2850ad);
  box-shadow: 0 0 0 3px var(--ca-surface-active, #eef3ff);
}

.dashboard-heading h1 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.65rem, 2.4vw, 2.15rem);
  font-weight: 750;
  letter-spacing: -0.045em;
  line-height: 1.2;
}

.dashboard-subtitle {
  max-width: 740px;
  margin: 0.65rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.65;
}

.dashboard-context {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 0 0 auto;
  padding: 0.7rem 0.9rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.context-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid #d8e3ff;
  border-radius: var(--ca-radius-md, 8px);
  background: #eef3ff;
  color: var(--ca-primary, #0e2e80);
  font-size: 1.05rem;
}

.dashboard-context > div {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.context-label {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.68rem;
  font-weight: 650;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.dashboard-context strong {
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
  font-weight: 700;
  white-space: nowrap;
}

.metrics-section {
  margin-bottom: 1.65rem;
}

.section-intro {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.9rem;
}

.section-intro h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1.05rem;
  font-weight: 750;
  letter-spacing: -0.015em;
}

.section-intro p {
  margin: 0.25rem 0 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.8rem;
}

.metrics-count, .panel-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.35rem 0.6rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 999px;
  background: var(--ca-surface, #fff);
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.7rem;
  font-weight: 650;
  white-space: nowrap;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}

.metric-card {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 200px;
  flex-direction: column;
  overflow: hidden;
  padding: 1.15rem 1.2rem 1.05rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.metric-card:hover {
  transform: translateY(-2px);
  border-color: var(--ca-border, #dfe4ec);
  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));
}

.metric-topline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  margin-bottom: 1.1rem;
}

.metric-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.55rem;
  height: 2.55rem;
  flex: 0 0 2.55rem;
  border-radius: 0.8rem;
  font-size: 1.1rem;
}

.metric-card--healthy .metric-icon {
  background: var(--ca-success-bg, #eaf7f0);
  color: var(--ca-success, #198754);
}

.metric-card--updated .metric-icon {
  background: var(--ca-warning-bg, #fff7e6);
  color: #b97700;
}

.metric-card--source .metric-icon {
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.metric-card--failures .metric-icon {
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
}

.metric-status {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.28rem 0.5rem;
  border-radius: 999px;
  font-size: 0.66rem;
  font-weight: 700;
  white-space: nowrap;
}

.metric-status > span {
  width: 0.35rem;
  height: 0.35rem;
  border-radius: 50%;
  background: currentColor;
}

.metric-status--success {
  background: var(--ca-success-bg, #eaf7f0);
  color: var(--ca-success, #198754);
}

.metric-status--info {
  background: var(--ca-info-bg, #eaf6fc);
  color: var(--ca-info, #1d7fbf);
}

.metric-status--primary {
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.metric-status--danger {
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
}

.metric-copy {
  min-width: 0;
}

.metric-copy h3 {
  margin: 0 0 0.35rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.8rem;
  font-weight: 650;
  line-height: 1.4;
}

.metric-value {
  overflow: hidden;
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.75rem, 2vw, 2.15rem);
  font-weight: 750;
  letter-spacing: -0.05em;
  line-height: 1.2;
  text-overflow: ellipsis;
}

.metric-description {
  margin: 0.45rem 0 0;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.72rem;
  line-height: 1.4;
}

.metric-accent {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  opacity: 0.8;
}

.metric-card--healthy .metric-accent {
  background: var(--ca-success, #198754);
}

.metric-card--updated .metric-accent {
  background: #d98c00;
}

.metric-card--source .metric-accent {
  background: var(--ca-primary-light, #2850ad);
}

.metric-card--failures .metric-accent {
  background: var(--ca-danger, #dc3545);
}

.dashboard-panels {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.15rem;
  align-items: stretch;
}

.dashboard-panel {
  display: flex;
  min-width: 0;
  min-height: 430px;
  flex-direction: column;
  padding: 1.15rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
}

.panel-heading-copy {
  min-width: 0;
}

.panel-title-line {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.panel-title-line h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.98rem;
  font-weight: 750;
  line-height: 1.4;
}

.panel-heading-copy > p {
  margin: 0.45rem 0 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.76rem;
  line-height: 1.5;
}

.panel-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.15rem;
  height: 2.15rem;
  flex: 0 0 2.15rem;
  border-radius: 0.65rem;
  font-size: 0.95rem;
}

.panel-icon--chart {
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.panel-icon--table {
  background: var(--ca-info-bg, #eaf6fc);
  color: var(--ca-info, #1d7fbf);
}

.panel-tag {
  margin-top: 0.1rem;
  background: var(--ca-bg, #f5f7fb);
}

.chart-content {
  position: relative;
  min-width: 0;
  height: 330px;
  padding-top: 1rem;
}

.chart-content canvas {
  display: block;
  width: 100% !important;
  height: 100% !important;
}

.chart-empty-state, .dashboard-unavailable {
  display: flex;
  min-height: 290px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 2rem 1rem;
  color: var(--ca-text-tertiary, #6f7b91);
  text-align: center;
}

.chart-empty-state > i, .dashboard-unavailable > i {
  color: var(--ca-primary-light, #2850ad);
  font-size: 2rem;
}

.chart-empty-state h3, .dashboard-unavailable h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1.05rem;
  font-weight: 750;
}

.chart-empty-state p, .dashboard-unavailable p {
  max-width: 30rem;
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
  line-height: 1.6;
}

@media (max-width: 1200px) {
  .metrics-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-panels {
    grid-template-columns: minmax(0, 1fr);
  }
  .dashboard-panel {
    min-height: 400px;
  }
}
@media (max-width: 767.98px) {
  .dashboard-page {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .dashboard-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1.5rem;
  }
  .dashboard-context {
    width: 100%;
  }
  .section-intro {
    align-items: flex-start;
  }
  .metrics-count, .panel-tag {
    display: none;
  }
  .metric-card {
    min-height: 185px;
    padding: 1rem;
  }
  .dashboard-panel {
    min-height: 360px;
    padding: 0.9rem;
  }
  .panel-header {
    align-items: flex-start;
  }
  .chart-content {
    height: 300px;
  }
}
@media (max-width: 480px) {
  .metrics-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .metric-card {
    min-height: auto;
  }
  .metric-topline {
    margin-bottom: 0.8rem;
  }
  .metric-value {
    font-size: 1.9rem;
  }
  .panel-title-line {
    align-items: flex-start;
  }
  .panel-title-line h2 {
    padding-top: 0.15rem;
  }
  .chart-content {
    height: 270px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .metric-card {
    transition: none;
  }
  .metric-card:hover {
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/data-protection/auth-tools/data-protection-dashboard/data-protection-dashboard.component.scss"],"names":[],"mappings":"AAAA;EAAQ,cAAA;EAAgB,YAAA;EAAc,sCAAA;AAItC;;AADA;EACE,kBAAA;EACA,mBAAA;AAIF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AAIF;;AADA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AAIF;AAFE;EACE,sCAAA;EACA,0BAAA;AAIJ;AADE;EACE,0CAAA;EACA,mBAAA;EACA,uCAAA;AAGJ;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,oCAAA;AAEF;;AACA;EAEE,wCAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;EAAa,iBAAA;EAAmB,cAAA;EAChC,iDAAA;EACA,sCAAA;AAGF;;AADA;EAAyB,sBAAA;AAKzB;;AAJA;EACE,aAAA;EAAe,qBAAA;EAAuB,8BAAA;EACtC,WAAA;EAAa,sBAAA;AAUf;;AARA;EAA0B,YAAA;AAY1B;;AAXA;EACE,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAa,mBAAA;EACjD,uCAAA;EAAyC,iBAAA;EACzC,gBAAA;EAAkB,sBAAA;AAmBpB;;AAjBA;EACE,cAAA;EAAgB,eAAA;EAAiB,kBAAA;EACjC,4CAAA;EACA,uDAAA;AAsBF;;AApBA;EACE,SAAA;EAAW,sCAAA;EACX,yCAAA;EAA2C,gBAAA;EAC3C,wBAAA;EAA0B,gBAAA;AA0B5B;;AAxBA;EACE,gBAAA;EAAkB,mBAAA;EAClB,wCAAA;EAA0C,iBAAA;EAAmB,iBAAA;AA8B/D;;AA5BA;EACE,aAAA;EAAe,mBAAA;EAAqB,YAAA;EAAc,cAAA;EAClD,sBAAA;EAAwB,iDAAA;EACxB,wCAAA;EAA0C,mCAAA;EAC1C,gEAAA;AAoCF;;AAlCA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAC3C,aAAA;EAAe,cAAA;EAAgB,yBAAA;EAC/B,uCAAA;EAAyC,mBAAA;EACzC,iCAAA;EAAmC,kBAAA;AA2CrC;;AAzCA;EAA2B,aAAA;EAAe,sBAAA;EAAwB,WAAA;AA+ClE;;AA9CA;EACE,oCAAA;EAAsC,kBAAA;EAAoB,gBAAA;EAC1D,sBAAA;EAAwB,yBAAA;AAoD1B;;AAlDA;EAA4B,sCAAA;EAAwC,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;AAyD1G;;AAxDA;EAAmB,sBAAA;AA4DnB;;AA3DA;EACE,aAAA;EAAe,qBAAA;EAAuB,8BAAA;EACtC,SAAA;EAAW,qBAAA;AAiEb;;AA/DA;EACE,SAAA;EAAW,sCAAA;EAAwC,kBAAA;EACnD,gBAAA;EAAkB,wBAAA;AAqEpB;;AAnEA;EAAmB,mBAAA;EAAqB,uCAAA;EAAyC,iBAAA;AAyEjF;;AAxEA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,WAAA;EACpE,uBAAA;EAAyB,iDAAA;EACzB,oBAAA;EAAsB,mCAAA;EACtB,uCAAA;EAAyC,iBAAA;EACzC,gBAAA;EAAkB,mBAAA;AAkFpB;;AAhFA;EAAgB,aAAA;EAAe,gDAAA;EAAkD,SAAA;AAsFjF;;AArFA;EACE,kBAAA;EAAoB,aAAA;EAAe,YAAA;EAAc,iBAAA;EAAmB,sBAAA;EACpE,gBAAA;EAAkB,+BAAA;EAClB,iDAAA;EAAmD,wCAAA;EACnD,mCAAA;EAAqC,gEAAA;EACrC,6EAAA;AA+FF;;AA7FA;EAAqB,2BAAA;EAA6B,uCAAA;EAAyC,iEAAA;AAmG3F;;AAlGA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,YAAA;EAAc,qBAAA;AA0GpG;;AAzGA;EAAe,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,cAAA;EAAgB,eAAA;EAAiB,iBAAA;EAAmB,qBAAA;EAAuB,iBAAA;AAoH9J;;AAnHA;EAAqC,yCAAA;EAA2C,iCAAA;AAwHhF;;AAvHA;EAAqC,yCAAA;EAA2C,cAAA;AA4HhF;;AA3HA;EAAoC,6CAAA;EAA+C,iCAAA;AAgInF;;AA/HA;EAAsC,wCAAA;EAA0C,gCAAA;AAoIhF;;AAnIA;EAAiB,oBAAA;EAAsB,mBAAA;EAAqB,YAAA;EAAc,uBAAA;EAAyB,oBAAA;EAAsB,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;AA8I/J;;AA7IA;EAAwB,cAAA;EAAgB,eAAA;EAAiB,kBAAA;EAAoB,wBAAA;AAoJ7E;;AAnJA;EAA0B,yCAAA;EAA2C,iCAAA;AAwJrE;;AAvJA;EAAuB,sCAAA;EAAwC,8BAAA;AA4J/D;;AA3JA;EAA0B,6CAAA;EAA+C,iCAAA;AAgKzE;;AA/JA;EAAyB,wCAAA;EAA0C,gCAAA;AAoKnE;;AAnKA;EAAe,YAAA;AAuKf;;AAtKA;EAAkB,mBAAA;EAAqB,wCAAA;EAA0C,iBAAA;EAAmB,gBAAA;EAAkB,gBAAA;AA8KtH;;AA7KA;EAAgB,gBAAA;EAAkB,SAAA;EAAW,sCAAA;EAAwC,uCAAA;EAAyC,gBAAA;EAAkB,uBAAA;EAAyB,gBAAA;EAAkB,uBAAA;AAwL3L;;AAvLA;EAAsB,mBAAA;EAAqB,oCAAA;EAAsC,kBAAA;EAAoB,gBAAA;AA8LrG;;AA7LA;EAAiB,kBAAA;EAAoB,QAAA;EAAU,SAAA;EAAW,OAAA;EAAS,WAAA;EAAa,YAAA;AAsMhF;;AArMA;EAAuC,sCAAA;AAyMvC;;AAxMA;EAAuC,mBAAA;AA4MvC;;AA3MA;EAAsC,4CAAA;AA+MtC;;AA9MA;EAAwC,qCAAA;AAkNxC;;AAjNA;EAAoB,aAAA;EAAe,gDAAA;EAAkD,YAAA;EAAc,oBAAA;AAwNnG;;AAvNA;EACE,aAAA;EAAe,YAAA;EAAc,iBAAA;EAAmB,sBAAA;EAAwB,gBAAA;EACxE,iDAAA;EAAmD,wCAAA;EACnD,mCAAA;EAAqC,gEAAA;AAgOvC;;AA9NA;EAAgB,aAAA;EAAe,uBAAA;EAAyB,8BAAA;EAAgC,SAAA;EAAW,oBAAA;EAAsB,wDAAA;AAuOzH;;AAtOA;EAAsB,YAAA;AA0OtB;;AAzOA;EAAoB,aAAA;EAAe,mBAAA;EAAqB,YAAA;AA+OxD;;AA9OA;EAAuB,SAAA;EAAW,sCAAA;EAAwC,kBAAA;EAAoB,gBAAA;EAAkB,gBAAA;AAsPhH;;AArPA;EAA0B,mBAAA;EAAqB,uCAAA;EAAyC,kBAAA;EAAoB,gBAAA;AA4P5G;;AA3PA;EAAc,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,cAAA;EAAgB,eAAA;EAAiB,iBAAA;EAAmB,sBAAA;EAAwB,kBAAA;AAsQ9J;;AArQA;EAAqB,6CAAA;EAA+C,iCAAA;AA0QpE;;AAzQA;EAAqB,sCAAA;EAAwC,8BAAA;AA8Q7D;;AA7QA;EAAa,kBAAA;EAAoB,iCAAA;AAkRjC;;AAjRA;EAAiB,kBAAA;EAAoB,YAAA;EAAc,aAAA;EAAe,iBAAA;AAwRlE;;AAvRA;EAAwB,cAAA;EAAgB,sBAAA;EAAwB,uBAAA;AA6RhE;;AA5RA;EACE,aAAA;EAAe,iBAAA;EAAmB,sBAAA;EAAwB,mBAAA;EAAqB,uBAAA;EAC/E,YAAA;EAAc,kBAAA;EAAoB,uCAAA;EAAyC,kBAAA;AAsS7E;;AApSA;EAAqD,uCAAA;EAAyC,eAAA;AAyS9F;;AAxSA;EAAmD,SAAA;EAAW,sCAAA;EAAwC,kBAAA;EAAoB,gBAAA;AA+S1H;;AA9SA;EAAiD,gBAAA;EAAkB,SAAA;EAAW,wCAAA;EAA0C,kBAAA;EAAoB,gBAAA;AAsT5I;;AArTA;EACE;IAAgB,gDAAA;EAyThB;EAxTA;IAAoB,qCAAA;EA2TpB;EA1TA;IAAmB,iBAAA;EA6TnB;AACF;AA5TA;EACE;IAAkB,qBAAA;IAAuB,oBAAA;EAgUzC;EA/TA;IAAqB,uBAAA;IAAyB,sBAAA;IAAwB,SAAA;IAAW,qBAAA;EAqUjF;EApUA;IAAqB,WAAA;EAuUrB;EAtUA;IAAiB,uBAAA;EAyUjB;EAxUA;IAA6B,aAAA;EA2U7B;EA1UA;IAAe,iBAAA;IAAmB,aAAA;EA8UlC;EA7UA;IAAmB,iBAAA;IAAmB,eAAA;EAiVtC;EAhVA;IAAgB,uBAAA;EAmVhB;EAlVA;IAAiB,aAAA;EAqVjB;AACF;AApVA;EACE;IAAgB,qCAAA;EAuVhB;EAtVA;IAAe,gBAAA;EAyVf;EAxVA;IAAkB,qBAAA;EA2VlB;EA1VA;IAAgB,iBAAA;EA6VhB;EA5VA;IAAoB,uBAAA;EA+VpB;EA9VA;IAAuB,oBAAA;EAiWvB;EAhWA;IAAiB,aAAA;EAmWjB;AACF;AAlWA;EACE;IAAe,gBAAA;EAqWf;EApWA;IAAqB,eAAA;EAuWrB;AACF","sourcesContent":[":host { display: block; min-width: 0; color: var(--ca-text-primary, #172033); }\r\n\r\n\r\n.breadcrumb {\r\n  margin-top: 1.5rem;\r\n  margin-left: 1.5rem;\r\n}\r\n\r\n.breadcrumb-nav {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  margin: 0 0 1.25rem;\r\n  color: var(--ca-text-tertiary, #6f7b91);\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.breadcrumb-link {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  padding: 0;\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--ca-primary, #0e2e80);\r\n  font: inherit;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    color: var(--ca-primary-dark, #0d2863);\r\n    text-decoration: underline;\r\n  }\r\n\r\n  &:focus-visible {\r\n    outline: 3px solid rgba(40, 80, 173, 0.25);\r\n    outline-offset: 3px;\r\n    border-radius: var(--ca-radius-sm, 6px);\r\n  }\r\n}\r\n\r\n.breadcrumb-link i {\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.breadcrumb-separator {\r\n  color: var(--ca-text-muted, #8c96a8);\r\n}\r\n\r\n.breadcrumb-current {\r\n  \r\n  color: var(--ca-text-secondary, #4b5870);\r\n  font-weight: 500;\r\n}\r\n\r\n.breadcrumb-current i {\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.dashboard-page {\r\n  width: 100%; max-width: 1600px; margin: 0 auto;\r\n  padding: 0.25rem clamp(0.75rem, 2vw, 1.5rem) 2rem;\r\n  color: var(--ca-text-primary, #172033);\r\n}\r\n.dashboard-breadcrumbs { margin-bottom: 1.15rem; }\r\n.dashboard-heading {\r\n  display: flex; align-items: flex-end; justify-content: space-between;\r\n  gap: 1.5rem; margin: 0.25rem 0 2rem;\r\n}\r\n.dashboard-heading-copy { min-width: 0; }\r\n.dashboard-eyebrow {\r\n  display: flex; align-items: center; gap: 0.5rem; margin: 0 0 0.55rem;\r\n  color: var(--ca-primary-light, #2850ad); font-size: 0.7rem;\r\n  font-weight: 800; letter-spacing: 0.12em;\r\n}\r\n.eyebrow-mark {\r\n  width: 0.45rem; height: 0.45rem; border-radius: 2px;\r\n  background: var(--ca-primary-light, #2850ad);\r\n  box-shadow: 0 0 0 3px var(--ca-surface-active, #eef3ff);\r\n}\r\n.dashboard-heading h1 {\r\n  margin: 0; color: var(--ca-text-primary, #172033);\r\n  font-size: clamp(1.65rem, 2.4vw, 2.15rem); font-weight: 750;\r\n  letter-spacing: -0.045em; line-height: 1.2;\r\n}\r\n.dashboard-subtitle {\r\n  max-width: 740px; margin: 0.65rem 0 0;\r\n  color: var(--ca-text-secondary, #4b5870); font-size: 0.9rem; line-height: 1.65;\r\n}\r\n.dashboard-context {\r\n  display: flex; align-items: center; gap: 0.75rem; flex: 0 0 auto;\r\n  padding: 0.7rem 0.9rem; border: 1px solid var(--ca-border-light, #e9edf3);\r\n  border-radius: var(--ca-radius-lg, 12px); background: var(--ca-surface, #fff);\r\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\r\n}\r\n.context-icon {\r\n  display: inline-flex; align-items: center; justify-content: center;\r\n  width: 2.5rem; height: 2.5rem; border: 1px solid #d8e3ff;\r\n  border-radius: var(--ca-radius-md, 8px); background: #eef3ff;\r\n  color: var(--ca-primary, #0e2e80); font-size: 1.05rem;\r\n}\r\n.dashboard-context > div { display: flex; flex-direction: column; gap: 0.1rem; }\r\n.context-label {\r\n  color: var(--ca-text-muted, #8c96a8); font-size: 0.68rem; font-weight: 650;\r\n  letter-spacing: 0.06em; text-transform: uppercase;\r\n}\r\n.dashboard-context strong { color: var(--ca-text-primary, #172033); font-size: 0.82rem; font-weight: 700; white-space: nowrap; }\r\n.metrics-section { margin-bottom: 1.65rem; }\r\n.section-intro {\r\n  display: flex; align-items: flex-end; justify-content: space-between;\r\n  gap: 1rem; margin-bottom: 0.9rem;\r\n}\r\n.section-intro h2 {\r\n  margin: 0; color: var(--ca-text-primary, #172033); font-size: 1.05rem;\r\n  font-weight: 750; letter-spacing: -0.015em;\r\n}\r\n.section-intro p { margin: 0.25rem 0 0; color: var(--ca-text-tertiary, #6f7b91); font-size: 0.8rem; }\r\n.metrics-count, .panel-tag {\r\n  display: inline-flex; align-items: center; justify-content: center; gap: 0.4rem;\r\n  padding: 0.35rem 0.6rem; border: 1px solid var(--ca-border-light, #e9edf3);\r\n  border-radius: 999px; background: var(--ca-surface, #fff);\r\n  color: var(--ca-text-tertiary, #6f7b91); font-size: 0.7rem;\r\n  font-weight: 650; white-space: nowrap;\r\n}\r\n.metrics-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 1rem; }\r\n.metric-card {\r\n  position: relative; display: flex; min-width: 0; min-height: 200px; flex-direction: column;\r\n  overflow: hidden; padding: 1.15rem 1.2rem 1.05rem;\r\n  border: 1px solid var(--ca-border-light, #e9edf3); border-radius: var(--ca-radius-lg, 12px);\r\n  background: var(--ca-surface, #fff); box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\r\n  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n.metric-card:hover { transform: translateY(-2px); border-color: var(--ca-border, #dfe4ec); box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08)); }\r\n.metric-topline { display: flex; align-items: center; justify-content: space-between; gap: 0.65rem; margin-bottom: 1.1rem; }\r\n.metric-icon { display: inline-flex; align-items: center; justify-content: center; width: 2.55rem; height: 2.55rem; flex: 0 0 2.55rem; border-radius: 0.8rem; font-size: 1.1rem; }\r\n.metric-card--healthy .metric-icon { background: var(--ca-success-bg, #eaf7f0); color: var(--ca-success, #198754); }\r\n.metric-card--updated .metric-icon { background: var(--ca-warning-bg, #fff7e6); color: #b97700; }\r\n.metric-card--source .metric-icon { background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); }\r\n.metric-card--failures .metric-icon { background: var(--ca-danger-bg, #fdecef); color: var(--ca-danger, #dc3545); }\r\n.metric-status { display: inline-flex; align-items: center; gap: 0.35rem; padding: 0.28rem 0.5rem; border-radius: 999px; font-size: 0.66rem; font-weight: 700; white-space: nowrap; }\r\n.metric-status > span { width: 0.35rem; height: 0.35rem; border-radius: 50%; background: currentColor; }\r\n.metric-status--success { background: var(--ca-success-bg, #eaf7f0); color: var(--ca-success, #198754); }\r\n.metric-status--info { background: var(--ca-info-bg, #eaf6fc); color: var(--ca-info, #1d7fbf); }\r\n.metric-status--primary { background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); }\r\n.metric-status--danger { background: var(--ca-danger-bg, #fdecef); color: var(--ca-danger, #dc3545); }\r\n.metric-copy { min-width: 0; }\r\n.metric-copy h3 { margin: 0 0 0.35rem; color: var(--ca-text-secondary, #4b5870); font-size: 0.8rem; font-weight: 650; line-height: 1.4; }\r\n.metric-value { overflow: hidden; margin: 0; color: var(--ca-text-primary, #172033); font-size: clamp(1.75rem, 2vw, 2.15rem); font-weight: 750; letter-spacing: -0.05em; line-height: 1.2; text-overflow: ellipsis; }\r\n.metric-description { margin: 0.45rem 0 0; color: var(--ca-text-muted, #8c96a8); font-size: 0.72rem; line-height: 1.4; }\r\n.metric-accent { position: absolute; right: 0; bottom: 0; left: 0; height: 3px; opacity: 0.8; }\r\n.metric-card--healthy .metric-accent { background: var(--ca-success, #198754); }\r\n.metric-card--updated .metric-accent { background: #d98c00; }\r\n.metric-card--source .metric-accent { background: var(--ca-primary-light, #2850ad); }\r\n.metric-card--failures .metric-accent { background: var(--ca-danger, #dc3545); }\r\n.dashboard-panels { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1.15rem; align-items: stretch; }\r\n.dashboard-panel {\r\n  display: flex; min-width: 0; min-height: 430px; flex-direction: column; padding: 1.15rem;\r\n  border: 1px solid var(--ca-border-light, #e9edf3); border-radius: var(--ca-radius-lg, 12px);\r\n  background: var(--ca-surface, #fff); box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\r\n}\r\n.panel-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 1rem; padding-bottom: 1rem; border-bottom: 1px solid var(--ca-border-light, #e9edf3); }\r\n.panel-heading-copy { min-width: 0; }\r\n.panel-title-line { display: flex; align-items: center; gap: 0.65rem; }\r\n.panel-title-line h2 { margin: 0; color: var(--ca-text-primary, #172033); font-size: 0.98rem; font-weight: 750; line-height: 1.4; }\r\n.panel-heading-copy > p { margin: 0.45rem 0 0; color: var(--ca-text-tertiary, #6f7b91); font-size: 0.76rem; line-height: 1.5; }\r\n.panel-icon { display: inline-flex; align-items: center; justify-content: center; width: 2.15rem; height: 2.15rem; flex: 0 0 2.15rem; border-radius: 0.65rem; font-size: 0.95rem; }\r\n.panel-icon--chart { background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); }\r\n.panel-icon--table { background: var(--ca-info-bg, #eaf6fc); color: var(--ca-info, #1d7fbf); }\r\n.panel-tag { margin-top: 0.1rem; background: var(--ca-bg, #f5f7fb); }\r\n.chart-content { position: relative; min-width: 0; height: 330px; padding-top: 1rem; }\r\n.chart-content canvas { display: block; width: 100% !important; height: 100% !important; }\r\n.chart-empty-state, .dashboard-unavailable {\r\n  display: flex; min-height: 290px; flex-direction: column; align-items: center; justify-content: center;\r\n  gap: 0.65rem; padding: 2rem 1rem; color: var(--ca-text-tertiary, #6f7b91); text-align: center;\r\n}\r\n.chart-empty-state > i, .dashboard-unavailable > i { color: var(--ca-primary-light, #2850ad); font-size: 2rem; }\r\n.chart-empty-state h3, .dashboard-unavailable h2 { margin: 0; color: var(--ca-text-primary, #172033); font-size: 1.05rem; font-weight: 750; }\r\n.chart-empty-state p, .dashboard-unavailable p { max-width: 30rem; margin: 0; color: var(--ca-text-secondary, #4b5870); font-size: 0.82rem; line-height: 1.6; }\r\n@media (max-width: 1200px) {\r\n  .metrics-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\r\n  .dashboard-panels { grid-template-columns: minmax(0, 1fr); }\r\n  .dashboard-panel { min-height: 400px; }\r\n}\r\n@media (max-width: 767.98px) {\r\n  .dashboard-page { padding-right: 0.5rem; padding-left: 0.5rem; }\r\n  .dashboard-heading { align-items: flex-start; flex-direction: column; gap: 1rem; margin-bottom: 1.5rem; }\r\n  .dashboard-context { width: 100%; }\r\n  .section-intro { align-items: flex-start; }\r\n  .metrics-count, .panel-tag { display: none; }\r\n  .metric-card { min-height: 185px; padding: 1rem; }\r\n  .dashboard-panel { min-height: 360px; padding: 0.9rem; }\r\n  .panel-header { align-items: flex-start; }\r\n  .chart-content { height: 300px; }\r\n}\r\n@media (max-width: 480px) {\r\n  .metrics-grid { grid-template-columns: minmax(0, 1fr); }\r\n  .metric-card { min-height: auto; }\r\n  .metric-topline { margin-bottom: 0.8rem; }\r\n  .metric-value { font-size: 1.9rem; }\r\n  .panel-title-line { align-items: flex-start; }\r\n  .panel-title-line h2 { padding-top: 0.15rem; }\r\n  .chart-content { height: 270px; }\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n  .metric-card { transition: none; }\r\n  .metric-card:hover { transform: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
